import { MantineColor, MantineSpacing } from '@mantine/core';
import { ChatMode, ChatState, FinalChunkData } from './chat/hooks/useChatMessages';

export type ContentPaneConfig = {
  bg?: MantineColor;
  p?: MantineSpacing;
};

export type ContentMeta = {
  pageType: string;
  entityId?: string;
  metadata?: Record<string, string>;
  chatMode?: ChatMode;
  onChatStateChange?: (state: ChatState, data?: FinalChunkData) => void;
  getDocumentContent?: () => string;
};

export type SiestaMode = 'action' | 'chat' | 'busy';

export const SiestaActionType = {
  LINK: 'link',
  CHAT: 'chat',
} as const;

export type SiestaActionType = (typeof SiestaActionType)[keyof typeof SiestaActionType];

export type SiestaAction =
  | {
      type: typeof SiestaActionType.LINK;
      id: string;
      label: string;
      description?: string;
      href: string;
    }
  | {
      type: typeof SiestaActionType.CHAT;
      id: string;
      label: string;
      description?: string;
      prompt?: string;
    };

export type AppContainerContextValue = {
  skipDefaultSidebar: boolean;
  setSkipDefaultSidebar: (skip: boolean) => void;
  sidebarContent: React.ReactNode | null;
  setSidebarContent: (content: React.ReactNode | null) => void;
  contentMeta: ContentMeta | null;
  setContentMeta: (meta: ContentMeta | null) => void;
  contentPaneConfig: ContentPaneConfig;
  setContentPaneConfig: (config: ContentPaneConfig) => void;
  siestaMode: SiestaMode;
  setSiestaMode: (mode: SiestaMode) => void;
  siestaBusyGlowTop: number | null;
  setSiestaBusyGlowTop: (top: number | null) => void;
  conversationId: string;
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
};
